import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';

import { AuthContext } from 'context/AuthContext';
import Header from 'views/Templates/Store/Header';
import useQueryParams from 'utils/hooks/useQueryParams';
import { ROUTES } from 'dictionary/routes';
import { router } from 'utils/routerUtils';

function Controller({ children = null }) {
  const { isLoggedIn, getLoginOrderID } = useContext(AuthContext);
  const { getParam } = useQueryParams();

  if (isLoggedIn) {
    const orderName = getLoginOrderID();
    const redirectPath = orderName
      ? router.getOrderDetailsRoute(orderName)
      : ROUTES.ROOT;
    const redirectTo = getParam('redirectTo', redirectPath);
    return <Redirect to={redirectTo} />;
  }

  return (
    <>
      <Header />
      {children}
    </>
  );
}

export function AuthRoute({ children = null, ...routeConfig }) {
  return (
    <Route {...routeConfig}>
      <Controller>{children}</Controller>
    </Route>
  );
}
